var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout-full',{staticClass:"model-list",attrs:{"breadcrumb":_vm.breadcrumb}},[_c('vin-search',{staticClass:"model-list__vin-search"}),_c('model-search',{staticClass:"model-list__model-search"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }